import { trans } from '@spotahome/soyuz/client';
import { getCurrencySymbolForISOCode } from '@spotahome/soyuz-currency';

import { MODAL_RULES_CONFIGURATION } from './modals';

const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

const BANK_HOLIDAYS = 'bank_holiday';

const LOCO_DICTIONARY = {
  minimumAndMaximumAge: feature =>
    trans(feature.locoKey, {
      min: feature.min,
      max: feature.max
    })
};

export const formatScheduleRanges = (moveInMoveOutRanges = []) => {
  const moveIn = [];
  const moveOut = [];

  moveInMoveOutRanges.forEach(range => {
    const rangeWithoutBankHolidays = range.days.filter(
      day => day !== BANK_HOLIDAYS
    );
    let daysRange = rangeWithoutBankHolidays
      .filter(day => day !== BANK_HOLIDAYS)
      .map(day => trans(`property.rule.moveInMoveOut.${day}`));

    const isConsecutive = rangeWithoutBankHolidays.every(
      (day, index, array) => {
        if (index === 0) return true;
        return DAYS.indexOf(day) - DAYS.indexOf(array[index - 1]) === 1;
      }
    );

    const hasBankHolidays = range.days.includes(BANK_HOLIDAYS);

    if (isConsecutive) {
      daysRange = `${daysRange[0]} - ${daysRange[daysRange.length - 1]}`;
    }

    if (hasBankHolidays) {
      daysRange = `${daysRange} & ${trans(
        'property.rule.moveInMoveOut.bank_holiday'
      ).toLowerCase()}`;
    }

    if (range.checkIn) {
      const hoursRange = [range.checkIn.from, range.checkIn.to].join(' - ');
      moveIn.push(`${daysRange}, ${hoursRange}`);
    }

    if (range.checkOut) {
      const hoursRange = [range.checkOut.from, range.checkOut.to].join(' - ');
      moveOut.push(`${daysRange}, ${hoursRange}`);
    }
  });
  let tip = '';

  if (moveIn.length && moveOut.length) {
    tip = trans('property.rule.moveInMoveOut.flexibleCheckInOut.tip');
  } else if (moveIn.length) {
    tip = trans('property.rule.moveInMoveOut.flexibleCheckIn.tip');
  } else if (moveOut.length) {
    tip = trans('property.rule.moveInMoveOut.flexibleCheckOut.tip');
  }

  return {
    moveIn,
    moveOut,
    tip
  };
};

export const formatFeaturesToChipList = (
  featureList = {},
  currency = 'EUR'
) => {
  const currencySymbol = getCurrencySymbolForISOCode(currency);
  return Object.entries(featureList)
    .filter(([key, feature]) => key !== '__typename' && feature?.locoKey)
    .map(([key, feature]) => {
      const { icon, locoKey } = feature;
      const name = LOCO_DICTIONARY[key]
        ? LOCO_DICTIONARY[key](feature)
        : locoKey;
      const translatedName = trans(name);

      const featureModalConfig = MODAL_RULES_CONFIGURATION[key];

      return {
        name: feature.price
          ? `${translatedName} (${currencySymbol})`
          : translatedName,
        onClick: featureModalConfig?.showModal(feature)
          ? featureModalConfig.onClick(feature, {
              currency,
              name: translatedName,
              icon
            })
          : null,
        value: true, // force to true to show the chip with no crossing line
        icon
      };
    })
    .filter(Boolean);
};

export const formatDocumentsToChipList = ({ requiredDocumentation }) => {
  if (requiredDocumentation?.documents?.length) {
    return requiredDocumentation.documents.map(document => {
      return {
        name: trans(document),
        value: true, // force to true to show the chip with no crossing line
        icon: 'description'
      };
    });
  }
  return [];
};
